/**
 * Bill Model
 *
 *
 *
 *
 */
import React, { useState, useEffect, useContext } from 'react';

import Model from './models';

import { Tag, Card, Typography, Button, message } from 'antd';

import { Items } from '.';

import BillDetailView from './../modules/common/components/bill-detail/bill-detail';

import { ApiUtils } from 'soxo-bootstrap-core';

const moment = require('moment-timezone');

const { Text } = Typography;

class Bill extends Model {
    constructor() {
        super();

        this.fields = [
            {
                field: 'opb_name',
                caption: 'Name',
            },
            {
                field: 'opb_opno',
                caption: 'num',
            },
            // {
            //     field: 'cold_tm',
            //     caption: 'Date'
            // },
            // {
            //     field: 'Collected By',
            //     caption: 'cold_user'
            // }
        ];

        // this.columns = ;
    }

    get id() {
        return 'opb_id';
    }

    get getEndpoint() {
        return 'opbill';
    }

    get path() {
        return `bills`;
    }

    get getName() {
        return this.modelName + `s`;
    }

    get modelName() {
        return `bill`;
    }

    disableAdd = () => {
        return true;
    };

    get columns() {
        return [
            {
                field: 'opb_name',
                render: (record) => {
                    return record.opb_name;
                },
                caption: 'Name',
            },
            {
                field: 'opb_gender',
                render: (record) => {
                    return <Tag color={record.opb_gender === 'Male' ? 'green' : 'orange'}>{record.opb_gender}</Tag>;
                },
                caption: 'Gender',
            },
            {
                field: 'opb_age',
                render: (record) => {
                    return record.opb_age;
                },
                caption: 'Age',
            },
            {
                field: 'opb_mobile',
                render: (record) => {
                    return record.opb_mobile;
                },
                caption: 'Mobile',
            },
            {
                field: 'opb_opno',
                render: (record) => {
                    return record.opb_opno;
                },
                caption: 'OP No.',
            },
            {
                // field: 'cold_amt',
                render: (record) => {
                    return record.opb_amt;
                },
                caption: 'Amount',
            },

            {
                // field: 'cold_amt',
                render: (record) => {
                    return record.opb_bdisamt;
                },
                caption: 'Discount',
            },

            {
                // field: 'cold_amt',
                render: (record) => {
                    return record.opb_netamt;
                },
                caption: 'Net Amount',
            },

            {
                // field: 'cold_amt',
                render: (record) => {
                    return record.opb_paidamt;
                },
                caption: 'Paid',
            },
            // {
            //     field: 'cold_dt',
            //     render: (record) => {
            //         return record.colldetails ? record.colldetails.cold_dt : null;
            //     },
            //     caption: 'Date'
            // },
            // {
            //     field: 'Collected By',
            //     render: (record) => {
            //         return record.colldetails ? record.colldetails.cold_user : null;
            //     },
            //     caption: 'cold_user'
            // },
            {
                field: 'opb_remarks',
                render: (record) => {
                    return record.opb_remarks;
                },
                caption: 'Remarks',
            },
        ];
    }

    getBillTypes = () => {
        return ApiUtils.get({
            url: `billingtypes?page=1&limit=10&btyp_billnocode=OP`,
        });
    };

    getCustomers = () => {
        return ApiUtils.get({
            url: `customer?page=1&limit=10`,
        });
    };

    applyCoupon = (coupon) => {
        return ApiUtils.get({
            url: `campgndiscountcoupons/${coupon}`,
        });
    };
    /**
     *Load trends based on mode and submode 
     * @param {*} formBody
     * @returns
     */
    loadTrends = (bill_id,record) => {
        return ApiUtils.get({
            url: `opbill/doctor-notes-trends?bill_id=${bill_id}&mode=${record.mode}&submode=${record.submode}`,
        });
    };
    /**
     * Function to cancel bill
     * @param {*} id
     * @param {*} formBody
     * @returns
     */
    cancelBill = (id, formBody) => {
        return ApiUtils.post({
            url: `opbill/cancel-bill/${id}`,
            formBody,
        });
    };
   

    validatecoupon = (formBody) => {
        return ApiUtils.post({
            url: `campgndiscountcoupons/validate`,
            formBody,
        });
    };

    /**
     * get bill details
     * @param {*} formBody
     * @returns
     */
    getBillPdf = (formBody) => {
        return ApiUtils.post({
            url: `opbill/opbill-pdf`,
            formBody,
        });
    };
    /**
     * Gte bill details for the corrsponding bill number or bill id, which ever is passed to the function
     * @param {*} id
     * @param {*} bill_no
     * @returns
     */
    getBillDetails = (id, bill_no) => {
        if (bill_no) {
            return ApiUtils.get({
                url: `opbill/get-bill-details?bill_no=${bill_no}`,
            });
        } else
            return ApiUtils.get({
                url: `opbill/get-bill-details?bill_id=${id}`,
            });
    };

    /**
     * Create a Bill with Items
     */
    createFinalBill = (formBody) => {
        return ApiUtils.post({
            url: `opbill/final_bill`,
            formBody,
        });
    };

    bill = async (formBody) => {
        // var items = [];
        formBody = {
            ...formBody,
        };
        return this.createFinalBill(formBody)
            .then((result) => {
                return result;
            })
            .catch((result) => {
                return result;
            });
    };

    DirectBill = (formBody) => {
        console.log(formBody);
        formBody = {
            ...formBody,
        };
        return this.createFinalBill(formBody)

            .then((result) => {
                return result;
            })
            .catch((result) => {
                return result;
            });
    };

    /**
     *
     *  create rewards
     *
     */

    createRewards = (formBody) => {
        return ApiUtils.post({
            url: `reward-transactions/create-rewards`,
            formBody,
        });
    };

    rewardList = (id, op_id, opb_opno) => {
        return ApiUtils.get({
            url: `reward-transactions/rewards-lists?reward_master_id=${id}&account_id_type=${op_id}&account_code=${opb_opno}`,
        });
    };

    /**
     * to check if lab billing is done
     */

    getLabBilled = (visit_id, item) => {
        return ApiUtils.get({
            url: `opbill/view-details?visit_id=${visit_id}&item=${item}`,
        });
    };

    /**
     *
     *  Active list
     *
     */

    getActiveList = () => {
        return ApiUtils.get({
            url: `reward-transactions/active-list`,
        });
    };

    getAuthList = () => {
        return ApiUtils.get({
            url: `reward-transactions/authorization-list`,
        });
    };

    /**
     *
     * Get Bill list table
     * @param {*} range
     * @returns
     */
    getbillList = (range) => {
        const start_time = moment(range[0]).format('MM/DD/YYYY');

        const end_time = moment(range[1]).format('MM/DD/YYYY');

        // let url = `opbill/bill-list?start_date=${start_time}&end_date=${end_time}`;

        return ApiUtils.get({
            url: `opbill/bill-list?start_date=${start_time}&end_date=${end_time}`,
        });
    };

    /**
     *
     * Get Credit list table
     * @param {*} range
     * @returns
     */
    // getCreditList = (formBody) => {

    //     console.log("corporateValue", formBody);

    //     // let { corporateValue, department, date } = formBody
    //     // let start_time;
    //     // let end_time;
    //     // if (formBody.start_time&&formBody.end_time) {
    //     //     start_time = moment(start_time).format('MM/DD/YYYY');

    //     //     end_time = moment(end_time).format('MM/DD/YYYY');
    //     // }

    //     // console.log("opNoooo",opNo);

    //     // Object.keys(formBody).forEach(key => {
    //     //     formBody[key] = moment(formBody[key]).format('MM/DD/YYYY');
    //     //   });

    //     //   console.log("formBodykeys",formBody);

    //     let url = `opbill/credit-list`

    //     // let url;
    //     // Assuming base URL is '/bills'
    //     // var baseUrl = '/bills';

    //     // Assuming you have parameters in an object
    //     // var params = {
    //     //     param1: 'value1',
    //     //     param2: 'value2'
    //     // };

    //     // let url;
    //     // if (formBody) {
    //     //     // Construct the URL
    //     //     url= baseUrl + '?' + new URLSearchParams(formBody).toString();

    //     //     console.log(url);
    //     // }else{
    //     //     url= baseUrl;
    //     // }
    //     // if (formBody) {
    //     //     // Convert date values to the desired format (MM/DD/YYYY)
    //     //     formBody.end_time = moment(formBody.end_time, "MM/DD/YYYY").format("MM/DD/YYYY");
    //     //     formBody.start_time = moment(formBody.start_time, "MM/DD/YYYY").format("MM/DD/YYYY");

    //     //     // Manually construct the query string for date parameters
    //     //     const dateParams = `end_time=${formBody.end_time}&start_time=${formBody.start_time}`;

    //     //     // Use URLSearchParams for other parameters
    //     //     const otherParams = new URLSearchParams(formBody);
    //     //     otherParams.delete('end_time');
    //     //     otherParams.delete('start_time');

    //     //     // Combine all parameters
    //     //     url = `${baseUrl}?${dateParams}&${otherParams.toString()}`;

    //     //     console.log(url);
    //     // } else {
    //     //     url = baseUrl;
    //     // }
    //     // if(opNo){
    //     //     url = `opNo=${opNo}`
    //     // }
    //     //  let url = new URL(`opbill/credit-list`)
    //     //  url.searchParams.append('corporateValue', corporateValue);
    //     //  url.searchParams.append('start_time', start_time);
    //     //  url.searchParams.append('end_time', end_time);
    //     // if (corporateValue) {
    //     //     // url.searchParams.append('corporateValue', corporateValue);
    //     //     url += `corporateValue=${corporateValue}`
    //     // }

    //     // //   if (start_time && end_time) {
    //     // //     url += `start_date=${start_time}&end_date=${end_time}`
    //     // //     // url.searchParams.append('start_time', start_time);
    //     // //     // url.searchParams.append('end_time', end_time);
    //     // // }

    //     // // if (department) {
    //     // //     url = url + `&department=${department}`
    //     // // }

    //     return ApiUtils.get({
    //         url
    //     });
    // };

    getCreditList(formBody) {
        return ApiUtils.post({
            url: `opbill/credit-list`,
            formBody,
            // opNo
        });
    }

    getCreditList(formBody) {
        return ApiUtils.post({
            url: `opbill/credit-list`,
            formBody,
            // opNo
        });
    }

    /**
     *
     * Get Bill list table
     * @param {*} range
     * @returns
     */
    getRewardList = (range) => {
        const start_time = moment(range[0]).format('MM/DD/YYYY');

        const end_time = moment(range[1]).format('MM/DD/YYYY');

        return ApiUtils.get({
            url: `opbill/reward-list?start_date=${start_time}&end_date=${end_time}`,
        });
    };

    getCollections = (bill_id) => {
        return ApiUtils.get({
            url: `colldetails/collection-load?cold_tranno=${bill_id}`,
        });
    };

    getOplist = (query) => {
        return ApiUtils.get({
            url: `opreg/visit-search?name=${query}`,
        });

        // return ApiUtils.get({
        //     url: `opbill/search/${query}`,
        // });
    };

    // getOperg = (op_no, da_id) => {
    //     return ApiUtils.get({
    //         url: `opreg/with-appointment?op_no=${op_no}&da_id=${da_id}`,
    //     });
    // };

    getOpRegData = (op_no) => {
        return ApiUtils.get({
            url: `opreg?op_no=${op_no}`,
        });
    };

    getScreeningTrend = (range) => {
        const start_date = moment(range[0]).format('MM/DD/YYYY');

        const end_date = moment(range[1]).format('MM/DD/YYYY');

        return ApiUtils.get({
            url: `opbill/screening-trend?start_date=${start_date}&end_date=${end_date}`,
        });
    };

    /**
     * Get Byte Array for the Report
     */
    getReport = (formBody) => {
        return ApiUtils.post({
            url: `opbill/patient-lab-report`,
            formBody,
        });
    };

    /**
     * Publish Reoprt
     */

    publishReport = (formBody) => {
        return ApiUtils.post({
            url: `opbill/patient-lab-report`,
            formBody,
        });
    };

    /**
     * Branch wise data
     *
     * @param {*} range
     * @returns
     */
    getScreeningTrendBranchWise = (range) => {
        const start_date = moment(range[0]).format('MM/DD/YYYY');

        const end_date = moment(range[1]).format('MM/DD/YYYY');

        return ApiUtils.get({
            url: `opbill/screening-trend-branchwise?start_date=${start_date}&end_date=${end_date}`,
        });
    };

    Card = ({ ...props }) => {
        return <GuestCard record={props} {...props}></GuestCard>;
    };

    DetailComponent = (routeParams) => <BillDetailView {...routeParams} model={this} />;
    //  AddComponent = () => <CollectionAdd model={this} />;

    /**
     *
     * @param {*} values
     * @returns
     */
    generateBill = async (values) => {
        // setModalVisible(true)

        var item = await Items.getItems('CXRAY');

        item = item.map((ele) => {
            return {
                ...ele,
                ir_rate: ele.itemrate[0].ir_rate,
                ir_itemptr: ele.itemrate[0].ir_itemptr,
            };
        });

        var formBody = {
            opb_opno: values.op_no,
            visit_id: values.visit_id,

            rate_type: '3', // Not sure if required
            opd_remarks: 'Chest Xray',
            category: 'GEN',

            billtype: 0,

            cmgdcpn_couponnumber: null,

            doctorptr: null,

            // refererptr: patient.opbill.opb_referrerptr,
        };

        return this.createBill(formBody, item)
            .then((result) => {
                if (result.OpBillD) message.success('Bill has been Successfully Created');
                return result;
            })
            .catch((result) => {
                // setBtnLoading(false);

                message.error(JSON.stringify(result.message));

                return result;
            });
    };
    /**
     * Loading bill numbers
     * @param {*} opno
     * @returns
     */
    loadbilllnumbers = (reference_number) => {
        return ApiUtils.get({
            url: `opbill/findByOpno?op_no=${reference_number}`,
        });
    };
    /**
     * Api call to get final report details
     * @param {*} id
     * @returns
     */
    getFinalReport = async (id) => {
        return ApiUtils.get({
            url: `opbill/get-report/${id}`,
            headers: {
                Authorization: 'Bearer' + ' ' + localStorage.access_token,
            },
        });
    };

    /**
     * Create Bill function
     * @param {*} formBody
     * @param {*} selected
     * @param {*} guest
     * @param {*} corporateptr
     * @param {*} discount
     * @param {*} coupon
     * @returns
     */
    createBill = async (formBody, summary, guest, corporateptr, discount, coupon, total,currencySymbol) => {
        var items = [];

        // Calculate discount && bill discount value for each package added
        let discountValue = 0;

        if (discount) {
            if (discount.type === '%') {
                discountValue = (total * discount.value) / 100;
                // Add the bill discount value
                formBody = {
                    ...formBody,
                    Bdiscount_per: discount.value,
                };
            } else if (discount.type ===currencySymbol) {
                discountValue = discount.value;
                // Add the bill discount value
                formBody = {
                    ...formBody,
                    Bdiscount_amt: discount.value,
                };
            }
        }

        if (coupon && coupon.coupon_amount) {
            discountValue = discountValue + coupon.coupon_amount;
        }

        let discountAmount = 0;

        if (discountValue > 0) {
            discountAmount = discountValue / total;
        }

        formBody = {
            ...formBody,
            items: summary.items.map((record) => {
                // console.log("reocrddddddddddd",record)
                // According to discount add item to items
                // if (record.discount) {
                //     if (record.discount.type === '%') {

                //         var item = {

                //             opbd_qty: 1,
                //             opbd_disper: record.discount.value,
                //         };

                //         items.push(item);

                //         formBody = {
                //             ...formBody,
                //             items,
                //         };
                //     } else if (record.discount.type === '₹') {
                //         // Add the bill discount value
                //         var item = {
                //             // opbd_itemptr: params.da_packagetypevalue,
                //             opbd_qty: 1,
                //             opbd_disamt: record.discount.value,
                //             //  opb_bdisamt:itmdiscount.opb_bdisamt,
                //         };
                //         items.push(item);

                //         formBody = {
                //             ...formBody,
                //             items,
                //         };
                //     }
                // } else {

                //     formBody = {
                //         ...formBody,

                //         // items,
                //     };
                // }
                // if (guest && guest.drAppointment && guest.drAppointment.da_couponno) {
                let itemTotal;

                if (guest && guest.drAppointment && guest.drAppointment.da_couponno) {
                    let difference = record.ir_rate - guest.drAppointment.da_couponvalue;

                    return {
                        opbd_itemptr: record.ir_itemptr,
                        opbd_qty: 1,
                        //  opbd_disamt: record.opb_bdisamt,
                        opbd_rate: difference,
                        billDiscountAmount: discountAmount ? parseFloat((difference * discountAmount).toFixed(2)) : 0,
                    };
                } else if (record.discount) {
                    if (record.discount.type === '%') {
                        itemTotal = record.amount - (record.amount * record.discount.value) / 100;

                        var item = {
                            // ...record,
                            opbd_itemptr: record.ir_itemptr,
                            opbd_qty: 1,
                            opbd_disper: record.discount.value,
                            opbd_rate: record.ir_rate,
                            billDiscountAmount: discountAmount ? parseFloat((itemTotal * discountAmount).toFixed(2)) : 0,
                        };
                    } else if (record.discount.type === currencySymbol) {
                        // Add the bill discount value
                        itemTotal = record.amount - record.discount.value;
                        var item = {
                            // ...record,
                            opbd_itemptr: record.ir_itemptr,
                            opbd_qty: 1,
                            opbd_disamt: record.discount.value,
                            opbd_rate: record.ir_rate,
                            billDiscountAmount: discountAmount ? parseFloat((itemTotal * discountAmount).toFixed(2)) : 0,
                        };
                    }

                    // let difference = record.ir_rate - record.discount.value;

                    return item;

                    // return {
                    //     opbd_itemptr: record.ir_itemptr,
                    //     opbd_qty: 1,
                    //     //  opbd_disamt: record.opb_bdisamt,
                    //     opbd_rate: difference,
                    // };
                } else {
                    return {
                        // opbd_itemptr: record.ir_itemptr,
                        opbd_itemptr: record.ir_itemptr,
                        opbd_qty: 1,
                        //  opbd_disamt: record.opb_bdisamt,
                        opbd_rate: record.ir_rate,
                        billDiscountAmount: discountAmount ? parseFloat((record.amount * discountAmount).toFixed(2)) : 0,
                    };
                }
            }),
        };

        // If its a corporate customer

        if (corporateptr) {
            formBody.opd_corporateptr = corporateptr;
        }

        // If its a campaign

        // Bill level discount

        // According to discount add item to items

        // Condition for adding bill level discount
        if (coupon && coupon.coupon_no && coupon.coupon_value) {
            formBody = {
                ...formBody,
                // cmgdcpn_couponnumber: coupon.dataValues.cmgdcpn_couponnumber,
                cmgdcpn_couponvalue: coupon.coupon_value,
            };
        } else {
        }

        if (guest && guest.drAppointment && guest.drAppointment.da_couponno && guest.drAppointment.da_couponvalue) {
            formBody = {
                ...formBody,
                cmgdcpn_couponnumber: guest.drAppointment.da_couponno,
                cmgdcpn_couponvalue: guest.drAppointment.da_couponvalue,

                // coupon_data: {
                //     coupon_no: guest.drAppointment.da_couponno,
                //     coupon_value: guest.drAppointment.da_couponvalue
                // }
            };
        }

        // Calculate the sum of billDiscountAmount for the first (n-1) items
        let sumOfDiscounts = formBody.items.slice(0, -1).reduce((sum, item) => sum + item.billDiscountAmount, 0);

        // Update the billDiscountAmount of the last item with the calculated sum
        formBody.items[formBody.items.length - 1].billDiscountAmount = discountValue - sumOfDiscounts;

        return this.createFinalBill(formBody)
            .then((result) => {
                return result;
            })
            .catch((result) => {
                return result;
            });
    };
}

function GuestCard({ record }) {
    return (
        <Card className="card vehicle-card">
            <div className="card">
                <h2 className="title">{record.opb_name}</h2>

                {/* {record.preReg.opb_age} */}

                {/* <h3 className="values">{record.da_aptime}</h3> */}

                {/* <Tag color={record.da_questfilled === 'F' ? 'orange' : 'green'}>{record.da_questfilled === 'F' ? 'Filled' : 'Pending'}</Tag> */}

                <Tag color="green">{record.opb_gender}</Tag>

                <Text type="secondary">{record.opb_mobile}</Text>

                <h4 className="values">{record.opb_opno}</h4>
            </div>
        </Card>
    );
}

export default Bill;
